/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.product = (await import('./pages/ProductContainer')).ProductContainer;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  product: {
    name: 'ProductContainer',
    componentName: 'ProductContainer',
    chunk: () => import('./pages/ProductContainer'),
    get component() {
      return ssr
        ? serverPages.product
        : currentRouteName === 'ProductContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer })))
    },
    path: '/:context?/p/:slug?/:itemId',
    varnish: true,
    channel: null
  },
});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
}
